import React from 'react';
import { DialogProps } from 'tdesign-react';

import NovaDialog from '@/components/dialog';

import styles from './index.module.less';

const ReviewDialog: React.FC<{
  visible: boolean;
  onClose: () => void
  children?: React.ReactNode;
  dialogConfig?: DialogProps
}> = (props) => {
  const { visible, onClose, children, dialogConfig } = props;
  return (
    <div className={styles.reviewDialog}>
      <NovaDialog
        dialogConfig={{
          style: { padding: 0, width: '800px', height: '500px', border: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'black' },
          visible,
          closeBtn: false,
          footer: null,
          header: null,
          closeOnOverlayClick: true,
          onClose,
          ...dialogConfig,
        }}
        isTransParent={true}
      >
        {visible ? children : null}
      </NovaDialog>
    </div>
  );
};

export default ReviewDialog;
